import { useState } from "react";

export const useToggle = (initialValue: boolean): [boolean, () => void] => {
  const [value, setValue] = useState(initialValue);
  return [value, () => setValue((currentValue) => !currentValue)];
};
